import { ReorderActiveBagWarningScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <ReorderActiveBagWarningScreen />;
}
